import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import { setMenu } from 'store/slice/SliceSidebar';
import Logo from 'components/ui-component/Logo';
import {config} from 'store/baseConfig';
import { useCommon } from 'hooks/hooksCommon';

// ==============================|| 메인 로고 ||============================== //

const LogoSection = () => {
    // const defaultId = useSelector((state) => state.sidebar.defaultId);
    const dispatch = useDispatch();
    const {navigate} = useCommon()
    const sidebar = useSelector((state) => state.sidebar);
    const sidebarDefaultId = sidebar.defaultId;
    
    const handleLogoClick = () => {
        dispatch(setMenu(false));
        navigate(config.defaultPath);

        // window.location.href = config.defaultPath;

    };

    return (
        <ButtonBase 
            disableRipple 
            onClick={handleLogoClick}
            style={{ textDecoration: 'none', color: 'inherit' }}
        >
            <Logo />
        </ButtonBase>
    );
};

export default LogoSection;
